export function unformatNumber(value: string | undefined) {
  if (value && value.match(/\d+/g)) {
    const parsedValue = parseInt(value.replace(/[^0-9-]+/g, ''), 10)
    return parsedValue
  }
  return ''
}
